import { Select, SelectProps } from "antd";
import { BaseOptionType } from "antd/es/cascader";
import { DefaultOptionType } from "antd/es/select";
import { valueType } from "antd/es/statistic/utils";
import SelectDropdownLgIcon from "../../assets/icons/SelectDropdownLgIcon";
import IMG from "../../assets/images/avatar.svg";
import { EmployeeData } from "../../types";
import UserWithImageNameTitle from "./UserWithImageNameTitle";

const { Option } = Select;

interface SelectImgNameTitleProps
  extends SelectProps<valueType, BaseOptionType | DefaultOptionType> {
  data?: EmployeeData[];
}

export default function SelectImgNameTitle({
  data,
  ...rest
}: SelectImgNameTitleProps) {
  const customRender = (id: number) => {
    const user = data?.find((user) => user.id === id);

    if (!user) return null;

    return (
      <UserWithImageNameTitle
        img={user?.member?.profile?.pro_pic || IMG}
        name={user?.member?.profile?.name}
        title={user?.role?.department?.name}
      />
    );
  };

  return (
    <Select
      style={{ width: "100%" }}
      optionLabelProp="label"
      rootClassName="select-user-with-image"
      allowClear
      suffixIcon={<SelectDropdownLgIcon />}
      filterOption={(input, option: any) =>
        option?.label?.props?.name?.toLowerCase().includes(input.toLowerCase())
      }
      {...rest}
    >
      {data?.map((user) => (
        <Option key={user.id} value={user.id} label={customRender(user.id)}>
          <UserWithImageNameTitle
            img={user?.member?.profile?.pro_pic || IMG}
            name={user?.member?.profile?.name}
            title={user?.role?.department?.name}
          />
        </Option>
      ))}
    </Select>
  );
}
